/**
 * Stripe config for the membership checkout flow (pay first, then create user).
 * Separate from the legacy flow (login → select package → pay) which uses .env.
 * Edit this file to set sandbox/live keys and mode.
 */

/** "sandbox" | "live" – which key to use */
export const checkoutStripeMode = "live";

/** Stripe publishable key for test mode (pk_test_...) */
export const checkoutStripePublishKeySandbox =
  "pk_test_51T2xiCRcQlcCZ3ONAV8SM95WPca71bHmz73GhJPusJKlCgPSNi1vhb77vSbpyfdbXAp2Cx1mb0b444tuTr3as7eB00zIFhYQxa";

/** Stripe publishable key for live mode (pk_live=_...) */
export const checkoutStripePublishKeyLive = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
/**
 * Resolves the Stripe publishable key for the membership checkout flow based on checkoutStripeMode.
 * @returns {string} pk_test_... or pk_live_... or empty string if not set
 */
export function getCheckoutStripePublishKey() {
  if (checkoutStripeMode === "live") return checkoutStripePublishKeyLive;
  return checkoutStripePublishKeySandbox;
}
